import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";
import { INBOUND_CORR_WB_REPORT } from "../constants/reportNames";


const createLinkAndDownload = ({fileName,fileData}) => {
    const href = URL.createObjectURL(fileData);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}

export const useGetReportTemplate = () => {
    return useMutation({
        mutationFn: async ({body,config}) => {
            //console.log("header is", config,"body is",body);
            return axios.get(`${process.env.REACT_APP_API_URI}DownloadTemplate?report=${body.report}`, config).then((response) => {
                if(response.data.error){
                    throw new Error(response.data.message)
                }
                if(body.report === INBOUND_CORR_WB_REPORT){
                    createLinkAndDownload({fileName:`${body.report}.csv`, fileData: response.data})
                }else{
                    createLinkAndDownload({fileName:`${body.report}.xlsx`, fileData: response.data})
                }
                
            }
            ).catch(err => err);
        },
    })
}